<div class="flex buttons-container">
  {{ "TransferHistoryToggle.TransferHistoryView" | translate }}:
  <mat-button-toggle-group
    appearance="legacy"
    (change)="viewToggler.emit(); toggleSelection($event.value)"
    name="fontStyle"
    aria-label="Font Style"
  >
    <mat-button-toggle
      [ngClass]="{ selected: currentSelection === 'receipts' }"
      value="receipts"
      >{{
        "TransferHistoryToggle.TransferHistoryReceipts" | translate
      }}</mat-button-toggle
    >
    <mat-button-toggle
      [ngClass]="{ selected: currentSelection === 'transfers' }"
      value="transfers"
      >{{
        "TransferHistoryToggle.TransferHistoryTransfers" | translate
      }}</mat-button-toggle
    >
  </mat-button-toggle-group>
</div>
